import { useQuery } from '@tanstack/react-query';
import { expertApi } from '../services/expertApi';

export function useBankerCycles(params: { days?: number; limit?: number; status?: string } = {}) {
  return useQuery({
    queryKey: ['banker-cycles', params],
    queryFn: () => expertApi.getBankerCycles(params),
    refetchInterval: 60_000,
  });
}

export function useBankerCycle(id: number | null) {
  return useQuery({
    queryKey: ['banker-cycle', id],
    queryFn: () => expertApi.getBankerCycle(id!),
    enabled: !!id,
  });
}
